var items = {
  "block.minecraft.air": "lufd",
  "block.minecraft.stone": "staa",
  "block.minecraft.granite": "granidd",
  "block.minecraft.polished_granite": "poliada granidd",
  "block.minecraft.diorite": "dioridd",
  "block.minecraft.polished_diorite": "poliede dioridd",
  "block.minecraft.andesite": "andesidd",
  "block.minecraft.polished_andesite": "poliede andesidd",
  "block.minecraft.grass_block": "groosblogg",
  "block.minecraft.dirt": "dregg",
  "block.minecraft.coarse_dirt": "groba dregg",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin-nezl",
  "block.minecraft.warped_nylium": "wirr-nezl",
  "block.minecraft.cobblestone": "bruchschdoi",
  "block.minecraft.oak_planks": "ächahulzbredda",
  "block.minecraft.spruce_planks": "fichdnhulzbredda",
  "block.minecraft.birch_planks": "berknhulzbredda",
  "block.minecraft.jungle_planks": "droubnhulzbredda",
  "block.minecraft.acacia_planks": "akazienhulzbredda",
  "block.minecraft.dark_oak_planks": "schwoazächahulzbredda",
  "block.minecraft.crimson_planks": "karmesinbredda",
  "block.minecraft.warped_planks": "wirrbredda",
  "block.minecraft.oak_sapling": "ächasetzling",
  "block.minecraft.spruce_sapling": "fichdnsetzling",
  "block.minecraft.birch_sapling": "berknsetzling",
  "block.minecraft.jungle_sapling": "droubnboamsetzling",
  "block.minecraft.acacia_sapling": "akaziensetzling",
  "block.minecraft.dark_oak_sapling": "schwoazächasetzling",
  "block.minecraft.bedrock": "grundgeschdein",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rouda sand",
  "block.minecraft.gravel": "kies",
  "block.minecraft.gold_ore": "goidätz",
  "block.minecraft.iron_ore": "aasnätz",
  "block.minecraft.coal_ore": "schdoikohl",
  "block.minecraft.nether_gold_ore": "nethergoidätz",
  "block.minecraft.oak_log": "ächaschdamm",
  "block.minecraft.spruce_log": "fichdnschdamm",
  "block.minecraft.birch_log": "berknschdamm",
  "block.minecraft.jungle_log": "droubnboamschdamm",
  "block.minecraft.acacia_log": "akazienschdamm",
  "block.minecraft.dark_oak_log": "schwoazächaschdamm",
  "block.minecraft.crimson_stem": "karmesinstiel",
  "block.minecraft.warped_stem": "wirrstiel",
  "block.minecraft.stripped_oak_log": "endrindeda ächaschdamm",
  "block.minecraft.stripped_spruce_log": "endrindeda fichdnschdamm",
  "block.minecraft.stripped_birch_log": "endrindeda berknschdamm",
  "block.minecraft.stripped_jungle_log": "endrindeda droubnboamschdamm",
  "block.minecraft.stripped_acacia_log": "endrindeda akazienschdamm",
  "block.minecraft.stripped_dark_oak_log": "endrindeda schwoazächaschdamm",
  "block.minecraft.stripped_crimson_stem": "geschälter karmesinstiel",
  "block.minecraft.stripped_warped_stem": "geschälter wirrstiel",
  "block.minecraft.stripped_oak_wood": "endindeds ächahulz",
  "block.minecraft.stripped_spruce_wood": "endrindeds fichdnhulz",
  "block.minecraft.stripped_birch_wood": "endrindeds berknhulz",
  "block.minecraft.stripped_jungle_wood": "endrindeds droubnhulz",
  "block.minecraft.stripped_acacia_wood": "endrindeds akazienhulz",
  "block.minecraft.stripped_dark_oak_wood": "endindeds schwoazächahulz",
  "block.minecraft.stripped_crimson_hyphae": "geschälte karmesinhyphen",
  "block.minecraft.stripped_warped_hyphae": "geschälte wirrhyphen",
  "block.minecraft.oak_wood": "ächahulz",
  "block.minecraft.spruce_wood": "fichdnhulz",
  "block.minecraft.birch_wood": "berknhulz",
  "block.minecraft.jungle_wood": "droubnhulz",
  "block.minecraft.acacia_wood": "akazienhulz",
  "block.minecraft.dark_oak_wood": "schwoazächahulz",
  "block.minecraft.crimson_hyphae": "karmesinhyphen",
  "block.minecraft.warped_hyphae": "wirrhyphen",
  "block.minecraft.oak_leaves": "ächalaab",
  "block.minecraft.spruce_leaves": "fichdnnoadln",
  "block.minecraft.birch_leaves": "berknlaab",
  "block.minecraft.jungle_leaves": "droubnboamlaab",
  "block.minecraft.acacia_leaves": "akazienlaab",
  "block.minecraft.dark_oak_leaves": "schwoazächalaab",
  "block.minecraft.sponge": "schwamm",
  "block.minecraft.wet_sponge": "nasser schwamm",
  "block.minecraft.glass": "glos",
  "block.minecraft.lapis_ore": "labislazuliätz",
  "block.minecraft.lapis_block": "labislazuliblogg",
  "block.minecraft.dispenser": "wärfa",
  "block.minecraft.sandstone": "sandschdoi",
  "block.minecraft.chiseled_sandstone": "gmeißelda sandschdoi",
  "block.minecraft.cut_sandstone": "gschniddena sandschdoi",
  "block.minecraft.note_block": "nodnblogg",
  "block.minecraft.powered_rail": "ontriebschiena",
  "block.minecraft.detector_rail": "sensorschiene",
  "block.minecraft.sticky_piston": "klebriga kolbm",
  "block.minecraft.cobweb": "spinnanetz",
  "block.minecraft.grass": "groos",
  "block.minecraft.fern": "faan",
  "block.minecraft.dead_bush": "doda bischl",
  "block.minecraft.seagrass": "herbier",
  "block.minecraft.sea_pickle": "seegurkn",
  "block.minecraft.piston": "kolbm",
  "block.minecraft.white_wool": "woaße woll",
  "block.minecraft.orange_wool": "orange woll",
  "block.minecraft.magenta_wool": "magenda woll",
  "block.minecraft.light_blue_wool": "hellblaue woll",
  "block.minecraft.yellow_wool": "gelbe woll",
  "block.minecraft.lime_wool": "hellgrine woll",
  "block.minecraft.pink_wool": "bingge woll",
  "block.minecraft.gray_wool": "graue woll",
  "block.minecraft.light_gray_wool": "hellgraue woll",
  "block.minecraft.cyan_wool": "dürgise woll",
  "block.minecraft.purple_wool": "violedde woll",
  "block.minecraft.blue_wool": "blaue woll",
  "block.minecraft.brown_wool": "broaune woll",
  "block.minecraft.green_wool": "grine woll",
  "block.minecraft.red_wool": "roude woll",
  "block.minecraft.black_wool": "schwoaze woll",
  "block.minecraft.dandelion": "lewnzohn",
  "block.minecraft.poppy": "mōn",
  "block.minecraft.blue_orchid": "blaua orchideen",
  "block.minecraft.allium": "ziealauch",
  "block.minecraft.azure_bluet": "boazellansteanchn",
  "block.minecraft.red_tulip": "roude dulbn",
  "block.minecraft.orange_tulip": "orange dulbn",
  "block.minecraft.white_tulip": "woaße dulbn",
  "block.minecraft.pink_tulip": "bingge dulbn",
  "block.minecraft.oxeye_daisy": "magaride",
  "block.minecraft.cornflower": "kornbluma",
  "block.minecraft.lily_of_the_valley": "maiglöckchn",
  "block.minecraft.wither_rose": "witherrousn",
  "block.minecraft.brown_mushroom": "broauna bilz",
  "block.minecraft.red_mushroom": "rouda bilz",
  "block.minecraft.crimson_fungus": "karmesinpilz",
  "block.minecraft.warped_fungus": "wirrpilz",
  "block.minecraft.crimson_roots": "karmesinwurzln",
  "block.minecraft.warped_roots": "wirrwurzln",
  "block.minecraft.nether_sprouts": "nethersprossn",
  "block.minecraft.weeping_vines": "trauerrankn",
  "block.minecraft.twisting_vines": "zwiablrankn",
  "block.minecraft.sugar_cane": "zuckarohr",
  "block.minecraft.kelp": "seetang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goidblogg",
  "block.minecraft.iron_block": "aasnblogg",
  "block.minecraft.oak_slab": "ächahulzschdufn",
  "block.minecraft.spruce_slab": "fichdnhulzschdufn",
  "block.minecraft.birch_slab": "berknhulzschdufn",
  "block.minecraft.jungle_slab": "droubnhulzschdufn",
  "block.minecraft.acacia_slab": "akazienhulzschdufn",
  "block.minecraft.dark_oak_slab": "schwoazeichnhulzschdufn",
  "block.minecraft.crimson_slab": "karmesinschdufn",
  "block.minecraft.warped_slab": "wirrschdufn",
  "block.minecraft.stone_slab": "schdoischdufn",
  "block.minecraft.smooth_stone_slab": "gladde schdoischdufn",
  "block.minecraft.sandstone_slab": "sandschdoischdufn",
  "block.minecraft.cut_sandstone_slab": "gschniddene sandschdoischdufn",
  "block.minecraft.petrified_oak_slab": "verschdainada eichnschdufn",
  "block.minecraft.cobblestone_slab": "bruchschdoischdufn",
  "block.minecraft.brick_slab": "zieglschdufn",
  "block.minecraft.stone_brick_slab": "schdoizieglschdufn",
  "block.minecraft.nether_brick_slab": "netherzieglschdufn",
  "block.minecraft.quartz_slab": "kwarzschdufn",
  "block.minecraft.red_sandstone_slab": "roude sandschdoischdufn",
  "block.minecraft.cut_red_sandstone_slab": "gschniddene roude sandschdoischdufn",
  "block.minecraft.purpur_slab": "purpurschdufn",
  "block.minecraft.prismarine_slab": "brismarinschdufn",
  "block.minecraft.prismarine_brick_slab": "brismarinziegelschdufn",
  "block.minecraft.dark_prismarine_slab": "dungle brismarinschdufn",
  "block.minecraft.smooth_quartz": "gladda kwarzblogg",
  "block.minecraft.smooth_red_sandstone": "gladda rouda sandschdoi",
  "block.minecraft.smooth_sandstone": "gladda sandschdoi",
  "block.minecraft.smooth_stone": "gladda schdoi",
  "block.minecraft.bricks": "ziegelstaa",
  "block.minecraft.tnt": "dnd",
  "block.minecraft.bookshelf": "bücharegal",
  "block.minecraft.mossy_cobblestone": "bmoosda bruchschdoi",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "faggl",
  "block.minecraft.end_rod": "endstoab",
  "block.minecraft.chorus_plant": "choruspflanzn",
  "block.minecraft.chorus_flower": "chorusblüdn",
  "block.minecraft.purpur_block": "purpurblogg",
  "block.minecraft.purpur_pillar": "purpursäuln",
  "block.minecraft.purpur_stairs": "purpurdrebbn",
  "block.minecraft.spawner": "spawna",
  "block.minecraft.oak_stairs": "ächahulzdrebbn",
  "block.minecraft.chest": "druhe",
  "block.minecraft.diamond_ore": "diormandätz",
  "block.minecraft.diamond_block": "diormandblogg",
  "block.minecraft.crafting_table": "werkbänk",
  "block.minecraft.farmland": "aggaland",
  "block.minecraft.furnace": "oufn",
  "block.minecraft.ladder": "loidan",
  "block.minecraft.rail": "schiene",
  "block.minecraft.cobblestone_stairs": "bruchschdoidrebbn",
  "block.minecraft.lever": "hebl",
  "block.minecraft.stone_pressure_plate": "staadruggbladdn",
  "block.minecraft.oak_pressure_plate": "ächahulzdruggbladdn",
  "block.minecraft.spruce_pressure_plate": "fichdnhulzdruggbladdn",
  "block.minecraft.birch_pressure_plate": "berknhulzdruggbladdn",
  "block.minecraft.jungle_pressure_plate": "droubnhulzdruggbladdn",
  "block.minecraft.acacia_pressure_plate": "akazienhulzdruggbladdn",
  "block.minecraft.dark_oak_pressure_plate": "schwoazächahulzdruggbladdn",
  "block.minecraft.crimson_pressure_plate": "karmesindruggbladdn",
  "block.minecraft.warped_pressure_plate": "wirrdruggbladdn",
  "block.minecraft.polished_blackstone_pressure_plate": "poliada schwoazschdoidruggbladdn",
  "block.minecraft.redstone_ore": "redstone-ätz",
  "block.minecraft.redstone_torch": "redstone-faggl",
  "block.minecraft.snow": "schnäh",
  "block.minecraft.ice": "ais",
  "block.minecraft.snow_block": "schnähblogg",
  "block.minecraft.cactus": "gagtus",
  "block.minecraft.clay": "leem",
  "block.minecraft.jukebox": "pladdnschbiela",
  "block.minecraft.oak_fence": "ächahulzzou",
  "block.minecraft.spruce_fence": "fichdnhulzzou",
  "block.minecraft.birch_fence": "berknhulzzou",
  "block.minecraft.jungle_fence": "droubnhulzzou",
  "block.minecraft.acacia_fence": "akazienhulzzaun",
  "block.minecraft.dark_oak_fence": "schwoazächahulzzou",
  "block.minecraft.crimson_fence": "karmesinzaun",
  "block.minecraft.warped_fence": "wirrzaun",
  "block.minecraft.pumpkin": "kärwis",
  "block.minecraft.carved_pumpkin": "g'schnitza küabis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelnsand",
  "block.minecraft.soul_soil": "seelnerde",
  "block.minecraft.basalt": "basaldd",
  "block.minecraft.polished_basalt": "poliada basald",
  "block.minecraft.soul_torch": "seelnfaggl",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "küabisladern",
  "block.minecraft.oak_trapdoor": "ächahulzfalldüe",
  "block.minecraft.spruce_trapdoor": "fichdnhulzfalldüe",
  "block.minecraft.birch_trapdoor": "berknhulzfalldüe",
  "block.minecraft.jungle_trapdoor": "droubnhulzfalldüe",
  "block.minecraft.acacia_trapdoor": "akazienhulzfalldüe",
  "block.minecraft.dark_oak_trapdoor": "schwoazächahulzfalldüe",
  "block.minecraft.crimson_trapdoor": "karmesinfalldüe",
  "block.minecraft.warped_trapdoor": "wirrfalldüe",
  "block.minecraft.infested_stone": "bfallnda schdoi",
  "block.minecraft.infested_cobblestone": "bfallnda bruchschdoi",
  "block.minecraft.infested_stone_bricks": "bfallnde schdoiziegl",
  "block.minecraft.infested_mossy_stone_bricks": "bfallnde bmoosde schdoiziegl",
  "block.minecraft.infested_cracked_stone_bricks": "bfallnde rissicha schdoiziegl",
  "block.minecraft.infested_chiseled_stone_bricks": "bfallnde gmeißelda schdoiziegl",
  "block.minecraft.stone_bricks": "stå zeigel",
  "block.minecraft.mossy_stone_bricks": "bmoosde stoaziegl",
  "block.minecraft.cracked_stone_bricks": "rissicha schdoiziegl",
  "block.minecraft.chiseled_stone_bricks": "gmeißelda schdoiziegl",
  "block.minecraft.brown_mushroom_block": "broauna bilzblogg",
  "block.minecraft.red_mushroom_block": "rouda bilzblogg",
  "block.minecraft.mushroom_stem": "bilzschdiel",
  "block.minecraft.iron_bars": "aasngidder",
  "block.minecraft.chain": "keddn",
  "block.minecraft.glass_pane": "glosschaim",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "rankn",
  "block.minecraft.oak_fence_gate": "eichnhulzzauntor",
  "block.minecraft.spruce_fence_gate": "fichdnhulzzauntor",
  "block.minecraft.birch_fence_gate": "berknhulzzauntor",
  "block.minecraft.jungle_fence_gate": "droubnhulzzauntor",
  "block.minecraft.acacia_fence_gate": "akazienhulzzauntor",
  "block.minecraft.dark_oak_fence_gate": "schwoazächazauntor",
  "block.minecraft.crimson_fence_gate": "karmesinzaundüa",
  "block.minecraft.warped_fence_gate": "wirrzaundüa",
  "block.minecraft.brick_stairs": "ziegldrebbn",
  "block.minecraft.stone_brick_stairs": "schdoiziegldrebbn",
  "block.minecraft.mycelium": "myzl",
  "block.minecraft.lily_pad": "seerosnbladd",
  "block.minecraft.nether_bricks": "netherziegl",
  "block.minecraft.cracked_nether_bricks": "rissicha netherziegl",
  "block.minecraft.chiseled_nether_bricks": "gmeißelda netherziegl",
  "block.minecraft.nether_brick_fence": "netherzieglzou",
  "block.minecraft.nether_brick_stairs": "netherziegldrebbn",
  "block.minecraft.enchanting_table": "zaubadisch",
  "block.minecraft.end_portal_frame": "endpoadalrahmn",
  "block.minecraft.end_stone": "endstaa",
  "block.minecraft.end_stone_bricks": "endstoaziegl",
  "block.minecraft.dragon_egg": "drachngaggeli",
  "block.minecraft.redstone_lamp": "redstone-lambm",
  "block.minecraft.sandstone_stairs": "sandschdoidrebbn",
  "block.minecraft.emerald_ore": "smaragdäaz",
  "block.minecraft.ender_chest": "enderdruhe",
  "block.minecraft.tripwire_hook": "hakn",
  "block.minecraft.emerald_block": "smaragdblogg",
  "block.minecraft.spruce_stairs": "fichdnhulzdrebbn",
  "block.minecraft.birch_stairs": "berknhulzdrebbn",
  "block.minecraft.jungle_stairs": "droubnhulzdrebbn",
  "block.minecraft.crimson_stairs": "karmesindrebbn",
  "block.minecraft.warped_stairs": "wirrdrebbn",
  "block.minecraft.command_block": "bfehlsblogg",
  "block.minecraft.beacon": "leuchdfeua",
  "block.minecraft.cobblestone_wall": "bruchschdoimaua",
  "block.minecraft.mossy_cobblestone_wall": "bmoosde bruchschdoimaua",
  "block.minecraft.brick_wall": "schdoizieglmaua",
  "block.minecraft.prismarine_wall": "brismarinmauer",
  "block.minecraft.red_sandstone_wall": "roude sandschdoimaua",
  "block.minecraft.mossy_stone_brick_wall": "bmoosde schdoizieglmaua",
  "block.minecraft.granite_wall": "graniddmaua",
  "block.minecraft.stone_brick_wall": "schdazieglmaua",
  "block.minecraft.nether_brick_wall": "netherzieglmaua",
  "block.minecraft.andesite_wall": "andesiddmaua",
  "block.minecraft.red_nether_brick_wall": "roude netherzieglmaua",
  "block.minecraft.sandstone_wall": "sandschdoimaua",
  "block.minecraft.end_stone_brick_wall": "endschdoizieglmaua",
  "block.minecraft.diorite_wall": "dioriddmaua",
  "block.minecraft.blackstone_wall": "schwoazschdoimaua",
  "block.minecraft.polished_blackstone_wall": "poliada schwoazschdoimaua",
  "block.minecraft.polished_blackstone_brick_wall": "poliada schwoazschdoizieglmaua",
  "block.minecraft.stone_button": "staagnobf",
  "block.minecraft.oak_button": "ächagnobf",
  "block.minecraft.spruce_button": "fichdngnobf",
  "block.minecraft.birch_button": "berkngnobf",
  "block.minecraft.jungle_button": "droubnhulzgnobf",
  "block.minecraft.acacia_button": "akazienhulzgnobf",
  "block.minecraft.dark_oak_button": "schwoazächahulzgnobf",
  "block.minecraft.crimson_button": "karmesingnobf",
  "block.minecraft.warped_button": "wirrknopf",
  "block.minecraft.polished_blackstone_button": "poliada schwoazschdoignobf",
  "block.minecraft.anvil": "amboß",
  "block.minecraft.chipped_anvil": "angschlachena amboss",
  "block.minecraft.damaged_anvil": "bschädigda amboss",
  "block.minecraft.trapped_chest": "redstone-druhe",
  "block.minecraft.light_weighted_pressure_plate": "fainwägplattn",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwägplattn",
  "block.minecraft.daylight_detector": "dageslichdsensoa",
  "block.minecraft.redstone_block": "redstone-blogg",
  "block.minecraft.nether_quartz_ore": "netherkwarzätz",
  "block.minecraft.hopper": "drichda",
  "block.minecraft.chiseled_quartz_block": "gmeißelda kwarzblogg",
  "block.minecraft.quartz_block": "kwarzblogg",
  "block.minecraft.quartz_bricks": "kwarzziegl",
  "block.minecraft.quartz_pillar": "kwarzsäuln",
  "block.minecraft.quartz_stairs": "kwarzdrebbn",
  "block.minecraft.activator_rail": "agdivierungsschiene",
  "block.minecraft.dropper": "spenda",
  "block.minecraft.white_terracotta": "woaße keramig",
  "block.minecraft.orange_terracotta": "orange keramig",
  "block.minecraft.magenta_terracotta": "magenda keramig",
  "block.minecraft.light_blue_terracotta": "hellblaue keramig",
  "block.minecraft.yellow_terracotta": "gelbe keramig",
  "block.minecraft.lime_terracotta": "hellgrine keramig",
  "block.minecraft.pink_terracotta": "bingge keramig",
  "block.minecraft.gray_terracotta": "graue keramig",
  "block.minecraft.light_gray_terracotta": "hellgraue keramig",
  "block.minecraft.cyan_terracotta": "dürgise keramig",
  "block.minecraft.purple_terracotta": "violedde keramig",
  "block.minecraft.blue_terracotta": "blaue keramig",
  "block.minecraft.brown_terracotta": "broaune keramig",
  "block.minecraft.green_terracotta": "grine keramig",
  "block.minecraft.red_terracotta": "roude keramig",
  "block.minecraft.black_terracotta": "schwoaze keramig",
  "block.minecraft.barrier": "barrier",
  "block.minecraft.iron_trapdoor": "aasnfalldüe",
  "block.minecraft.hay_block": "schdruabolln",
  "block.minecraft.white_carpet": "woaßa debbich",
  "block.minecraft.orange_carpet": "oranga debbich",
  "block.minecraft.magenta_carpet": "magenda debbich",
  "block.minecraft.light_blue_carpet": "hellblaua debbich",
  "block.minecraft.yellow_carpet": "gelba debbich",
  "block.minecraft.lime_carpet": "hellgrina debbich",
  "block.minecraft.pink_carpet": "bingga debbich",
  "block.minecraft.gray_carpet": "graua debbich",
  "block.minecraft.light_gray_carpet": "hellgraua debbich",
  "block.minecraft.cyan_carpet": "dürgisa debbich",
  "block.minecraft.purple_carpet": "violedda debbich",
  "block.minecraft.blue_carpet": "blaua debbich",
  "block.minecraft.brown_carpet": "broauna debbich",
  "block.minecraft.green_carpet": "grina debbich",
  "block.minecraft.red_carpet": "rouda debbich",
  "block.minecraft.black_carpet": "schwoaza debbich",
  "block.minecraft.terracotta": "keramig",
  "block.minecraft.coal_block": "kohlblogg",
  "block.minecraft.packed_ice": "baggais",
  "block.minecraft.acacia_stairs": "akazienhulzdrebbn",
  "block.minecraft.dark_oak_stairs": "schwoazächahulzdrebbn",
  "block.minecraft.slime_block": "schloimblogg",
  "block.minecraft.grass_path": "dramblpfoad",
  "block.minecraft.sunflower": "sunnebloeme",
  "block.minecraft.lilac": "flieder",
  "block.minecraft.rose_bush": "rousnbischl",
  "block.minecraft.peony": "hunnertbletarousn",
  "block.minecraft.tall_grass": "hoch’s groos",
  "block.minecraft.large_fern": "großa faan",
  "block.minecraft.white_stained_glass": "woaßes glos",
  "block.minecraft.orange_stained_glass": "oranges glos",
  "block.minecraft.magenta_stained_glass": "magenda glos",
  "block.minecraft.light_blue_stained_glass": "hellblaues glos",
  "block.minecraft.yellow_stained_glass": "gelbes glos",
  "block.minecraft.lime_stained_glass": "hellgrines glos",
  "block.minecraft.pink_stained_glass": "bingges glos",
  "block.minecraft.gray_stained_glass": "graues glos",
  "block.minecraft.light_gray_stained_glass": "hellgraues glos",
  "block.minecraft.cyan_stained_glass": "dürgises glos",
  "block.minecraft.purple_stained_glass": "violeddes glos",
  "block.minecraft.blue_stained_glass": "blaues glos",
  "block.minecraft.brown_stained_glass": "broaunes glos",
  "block.minecraft.green_stained_glass": "grines glos",
  "block.minecraft.red_stained_glass": "roudes glos",
  "block.minecraft.black_stained_glass": "schwoazes glos",
  "block.minecraft.white_stained_glass_pane": "woaße glosschaim",
  "block.minecraft.orange_stained_glass_pane": "orange glosschaim",
  "block.minecraft.magenta_stained_glass_pane": "magenda glosschaim",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaue glosschaim",
  "block.minecraft.yellow_stained_glass_pane": "gelbe glosschaim",
  "block.minecraft.lime_stained_glass_pane": "hellgrine glosschaim",
  "block.minecraft.pink_stained_glass_pane": "bingge glosschaim",
  "block.minecraft.gray_stained_glass_pane": "graue glosschaim",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraue glosschaim",
  "block.minecraft.cyan_stained_glass_pane": "dürgise glosschaim",
  "block.minecraft.purple_stained_glass_pane": "violedde glosschaim",
  "block.minecraft.blue_stained_glass_pane": "blaue glosschaim",
  "block.minecraft.brown_stained_glass_pane": "broaune glosschaim",
  "block.minecraft.green_stained_glass_pane": "grine glosschaim",
  "block.minecraft.red_stained_glass_pane": "roude glosschaim",
  "block.minecraft.black_stained_glass_pane": "schwoaze glosschaim",
  "block.minecraft.prismarine": "brismarin",
  "block.minecraft.prismarine_bricks": "brismarinblogg",
  "block.minecraft.dark_prismarine": "dungler brismarin",
  "block.minecraft.prismarine_stairs": "prismarindrebbn",
  "block.minecraft.prismarine_brick_stairs": "prismarinziegldrebbn",
  "block.minecraft.dark_prismarine_stairs": "dungle prismarindrebbn",
  "block.minecraft.sea_lantern": "seeladern",
  "block.minecraft.red_sandstone": "rouda sandschdoi",
  "block.minecraft.chiseled_red_sandstone": "gmeißelda rouda sandschdoi",
  "block.minecraft.cut_red_sandstone": "gschniddena rouda sandschdoi",
  "block.minecraft.red_sandstone_stairs": "roude sandschdoidrebbn",
  "block.minecraft.repeating_command_block": "wiedahol-bfehlsblogg",
  "block.minecraft.chain_command_block": "keddn-bfehlsblogg",
  "block.minecraft.magma_block": "magmablogg",
  "block.minecraft.nether_wart_block": "netherwarzblogg",
  "block.minecraft.warped_wart_block": "wirrwarznblogg",
  "block.minecraft.red_nether_bricks": "rode netherziegl",
  "block.minecraft.bone_block": "knochnblogg",
  "block.minecraft.structure_void": "konsdrugtiondsleere",
  "block.minecraft.observer": "bobachda",
  "block.minecraft.shulker_box": "shulkerkischdla",
  "block.minecraft.white_shulker_box": "woaße shulkerkischdla",
  "block.minecraft.orange_shulker_box": "orange shulkerkischdla",
  "block.minecraft.magenta_shulker_box": "magenda shulkerkischdla",
  "block.minecraft.light_blue_shulker_box": "hellblaue shulkerkischdla",
  "block.minecraft.yellow_shulker_box": "gelbe shulkerkischdla",
  "block.minecraft.lime_shulker_box": "hellgrine shulkerkischdla",
  "block.minecraft.pink_shulker_box": "bingge shulkerkischdla",
  "block.minecraft.gray_shulker_box": "graue shulkerkischdla",
  "block.minecraft.light_gray_shulker_box": "hellgraue shulkerkischdla",
  "block.minecraft.cyan_shulker_box": "dürgise shulkerkischdla",
  "block.minecraft.purple_shulker_box": "violedde shulkerkischdla",
  "block.minecraft.blue_shulker_box": "blaue shulkerkischdla",
  "block.minecraft.brown_shulker_box": "broaune shulkerkischdla",
  "block.minecraft.green_shulker_box": "grine shulkerkischdla",
  "block.minecraft.red_shulker_box": "roude shulkerkischdla",
  "block.minecraft.black_shulker_box": "schwoaze shulkerkischdla",
  "block.minecraft.white_glazed_terracotta": "woaße gloasierde keramig",
  "block.minecraft.orange_glazed_terracotta": "orange gloasierde keramig",
  "block.minecraft.magenta_glazed_terracotta": "magenda gloasierde keramig",
  "block.minecraft.light_blue_glazed_terracotta": "hellblaue gloasierde keramig",
  "block.minecraft.yellow_glazed_terracotta": "gelbe gloasierde keramig",
  "block.minecraft.lime_glazed_terracotta": "hellgrine gloasierde keramig",
  "block.minecraft.pink_glazed_terracotta": "bingge gloasierde keramig",
  "block.minecraft.gray_glazed_terracotta": "graue gloasierde keramig",
  "block.minecraft.light_gray_glazed_terracotta": "hellgraue gloasierde keramig",
  "block.minecraft.cyan_glazed_terracotta": "dürgise gloasierde keramig",
  "block.minecraft.purple_glazed_terracotta": "violedde gloasierde keramig",
  "block.minecraft.blue_glazed_terracotta": "blaue gloasierde keramig",
  "block.minecraft.brown_glazed_terracotta": "broaune gloasierde keramig",
  "block.minecraft.green_glazed_terracotta": "grine gloasierde keramig",
  "block.minecraft.red_glazed_terracotta": "roude gloasierde keramig",
  "block.minecraft.black_glazed_terracotta": "schwoaze gloasierde keramig",
  "block.minecraft.white_concrete": "woaßa bedon",
  "block.minecraft.orange_concrete": "oranga bedon",
  "block.minecraft.magenta_concrete": "magenda bedon",
  "block.minecraft.light_blue_concrete": "hellblaua bedon",
  "block.minecraft.yellow_concrete": "gelba bedon",
  "block.minecraft.lime_concrete": "hellgrina bedon",
  "block.minecraft.pink_concrete": "bingga bedon",
  "block.minecraft.gray_concrete": "graua bedon",
  "block.minecraft.light_gray_concrete": "hellgraua bedon",
  "block.minecraft.cyan_concrete": "dürgisa bedon",
  "block.minecraft.purple_concrete": "violedda bedon",
  "block.minecraft.blue_concrete": "blaua bedon",
  "block.minecraft.brown_concrete": "broauna bedon",
  "block.minecraft.green_concrete": "grina bedon",
  "block.minecraft.red_concrete": "rouda bedon",
  "block.minecraft.black_concrete": "schwoaza bedon",
  "block.minecraft.white_concrete_powder": "woaßa druggnbedon",
  "block.minecraft.orange_concrete_powder": "oranga druggnbedon",
  "block.minecraft.magenta_concrete_powder": "magenda druggnbedon",
  "block.minecraft.light_blue_concrete_powder": "hellblaua druggnbedon",
  "block.minecraft.yellow_concrete_powder": "gelba druggnbedon",
  "block.minecraft.lime_concrete_powder": "hellgrina druggnbedon",
  "block.minecraft.pink_concrete_powder": "bingga druggnbedon",
  "block.minecraft.gray_concrete_powder": "graua druggnbedon",
  "block.minecraft.light_gray_concrete_powder": "hellgraua druggnbedon",
  "block.minecraft.cyan_concrete_powder": "dürgisa druggnbedon",
  "block.minecraft.purple_concrete_powder": "violedda druggnbedon",
  "block.minecraft.blue_concrete_powder": "blaua druggnbedon",
  "block.minecraft.brown_concrete_powder": "broauna druggnbedon",
  "block.minecraft.green_concrete_powder": "grina druggnbedon",
  "block.minecraft.red_concrete_powder": "rouda druggnbedon",
  "block.minecraft.black_concrete_powder": "schwoaza druggnbedon",
  "block.minecraft.turtle_egg": "schildgrödnei",
  "block.minecraft.dead_tube_coral_block": "doda orgelgrallenblogg",
  "block.minecraft.dead_brain_coral_block": "doda herngrallnblogg",
  "block.minecraft.dead_bubble_coral_block": "doda blaasngrallnblogg",
  "block.minecraft.dead_fire_coral_block": "doda feuagrallnblogg",
  "block.minecraft.dead_horn_coral_block": "doda gweihgrallnblogg",
  "block.minecraft.tube_coral_block": "orgelgrallnblogg",
  "block.minecraft.brain_coral_block": "herngrallnblogg",
  "block.minecraft.bubble_coral_block": "blaasngrallnblogg",
  "block.minecraft.fire_coral_block": "feuagrallnblogg",
  "block.minecraft.horn_coral_block": "gweihgrallnblogg",
  "block.minecraft.tube_coral": "orgelgralle",
  "block.minecraft.brain_coral": "herngralle",
  "block.minecraft.bubble_coral": "blaasngralle",
  "block.minecraft.fire_coral": "feuagralle",
  "block.minecraft.horn_coral": "gweihgralle",
  "block.minecraft.dead_brain_coral": "dode herngralle",
  "block.minecraft.dead_bubble_coral": "dode blaasngralle",
  "block.minecraft.dead_fire_coral": "dode feuagralle",
  "block.minecraft.dead_horn_coral": "dode gweihgralle",
  "block.minecraft.dead_tube_coral": "dode orgelgralle",
  "block.minecraft.tube_coral_fan": "orgelgrallnfächa",
  "block.minecraft.brain_coral_fan": "herngrallnfächa",
  "block.minecraft.bubble_coral_fan": "blaasngrallnfächa",
  "block.minecraft.fire_coral_fan": "feuagrallnfächa",
  "block.minecraft.horn_coral_fan": "gweihgrallnfächa",
  "block.minecraft.dead_tube_coral_fan": "doda orgelgrallnfächa",
  "block.minecraft.dead_brain_coral_fan": "doda herngrallnfächa",
  "block.minecraft.dead_bubble_coral_fan": "doda blaasngrallnfächa",
  "block.minecraft.dead_fire_coral_fan": "doda feuagrallnfächa",
  "block.minecraft.dead_horn_coral_fan": "doda gweihgrallnfächa",
  "block.minecraft.blue_ice": "blauais",
  "block.minecraft.conduit": "aquisador",
  "block.minecraft.polished_granite_stairs": "poliada granidddrebbn",
  "block.minecraft.smooth_red_sandstone_stairs": "gladde roude sandschdoidrebbn",
  "block.minecraft.mossy_stone_brick_stairs": "bmoosde schdoiziegldrebbn",
  "block.minecraft.polished_diorite_stairs": "poliada dioriddrebbn",
  "block.minecraft.mossy_cobblestone_stairs": "bmoosde bruchschdoidrebbn",
  "block.minecraft.end_stone_brick_stairs": "endschdoiziegldrebbn",
  "block.minecraft.stone_stairs": "schdoidrebbn",
  "block.minecraft.smooth_sandstone_stairs": "gladde sandschdoidrebbn",
  "block.minecraft.smooth_quartz_stairs": "gladde kwarzdrebbn",
  "block.minecraft.granite_stairs": "granidddrebbn",
  "block.minecraft.andesite_stairs": "andesidddrebbn",
  "block.minecraft.red_nether_brick_stairs": "roude netherziegldrebbn",
  "block.minecraft.polished_andesite_stairs": "poliada andesidddrebbn",
  "block.minecraft.diorite_stairs": "dioriddrebbn",
  "block.minecraft.polished_granite_slab": "poliada graniddschdufn",
  "block.minecraft.smooth_red_sandstone_slab": "gladde roude sandschdoischdufn",
  "block.minecraft.mossy_stone_brick_slab": "bmoosde stoazieglschdufn",
  "block.minecraft.polished_diorite_slab": "poliada dioridschdufn",
  "block.minecraft.mossy_cobblestone_slab": "bmoosde bruchschdoischdufn",
  "block.minecraft.end_stone_brick_slab": "endschdoizieglschdufn",
  "block.minecraft.smooth_sandstone_slab": "gladde sandschdoischdufn",
  "block.minecraft.smooth_quartz_slab": "gladde kwarzschdufn",
  "block.minecraft.granite_slab": "graniddschdufn",
  "block.minecraft.andesite_slab": "andesiddschdufn",
  "block.minecraft.red_nether_brick_slab": "roude netherzieglschdufn",
  "block.minecraft.polished_andesite_slab": "poliada andesiddschdufn",
  "block.minecraft.diorite_slab": "dioridschdufn",
  "block.minecraft.scaffolding": "grüsdd",
  "block.minecraft.iron_door": "aasndüe",
  "block.minecraft.oak_door": "ächahulzdüe",
  "block.minecraft.spruce_door": "fichdnhulzdüe",
  "block.minecraft.birch_door": "berknhulzdüe",
  "block.minecraft.jungle_door": "droubnhulzdüe",
  "block.minecraft.acacia_door": "akazienhulzdüe",
  "block.minecraft.dark_oak_door": "schwoazächahulzdüe",
  "block.minecraft.crimson_door": "karmesindüe",
  "block.minecraft.warped_door": "wirrdüe",
  "block.minecraft.repeater": "redstone-verstärka",
  "block.minecraft.comparator": "redstone-kombaradoa",
  "block.minecraft.structure_block": "konsdrugtiondsblogg",
  "block.minecraft.jigsaw": "veabundsblogg",
  "item.minecraft.turtle_helmet": "schildgrödnbanza□□oaf dem deetz:□+2 rüsdung",
  "item.minecraft.scute": "honnschild",
  "item.minecraft.iron_shovel": "aasnschaufl□□in dea haubdhand:□+3.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.iron_pickaxe": "aasnpickl□□in dea haubdhand:□+3 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.iron_axe": "aasnbarte□□in dea haubdhand:□+8 oangriffsschadn□-3.1 oangriffsgschwindichkeid",
  "item.minecraft.flint_and_steel": "feuazeuch",
  "item.minecraft.apple": "abfl",
  "item.minecraft.bow": "boochn",
  "item.minecraft.arrow": "pfail",
  "item.minecraft.coal": "kohl",
  "item.minecraft.charcoal": "hulzkohl",
  "item.minecraft.diamond": "diormand",
  "item.minecraft.iron_ingot": "aasnboa",
  "item.minecraft.gold_ingot": "goidboa",
  "item.minecraft.netherite_ingot": "netheritboa",
  "item.minecraft.netherite_scrap": "netheritbladdn",
  "item.minecraft.iron_sword": "aasnschwerd□□in dea haubdhand:□+5 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.wooden_sword": "hulzschwerd□□in dea haubdhand:□+3 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.wooden_shovel": "hulzschaufl□□in dea haubdhand:□+1.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.wooden_pickaxe": "hulzpickl□□in dea haubdhand:□+1 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.wooden_axe": "hulzbarte□□in dea haubdhand:□+6 oangriffsschadn□-3.2 oangriffsgschwindichkeid",
  "item.minecraft.stone_sword": "staanschwerd□□in dea haubdhand:□+4 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.stone_shovel": "staaschaufl□□in dea haubdhand:□+2.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.stone_pickaxe": "staapickl□□in dea haubdhand:□+2 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.stone_axe": "staabarte□□in dea haubdhand:□+8 oangriffsschadn□-3.2 oangriffsgschwindichkeid",
  "item.minecraft.diamond_sword": "diormandschwerd□□in dea haubdhand:□+6 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.diamond_shovel": "diormandschaufl□□in dea haubdhand:□+4.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.diamond_pickaxe": "diormandpickl□□in dea haubdhand:□+4 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.diamond_axe": "diormandbarte□□in dea haubdhand:□+8 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.stick": "schdegge",
  "item.minecraft.bowl": "schüssl",
  "item.minecraft.mushroom_stew": "bilzsubbn",
  "item.minecraft.golden_sword": "goidschwerd□□in dea haubdhand:□+3 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.golden_shovel": "goidschaufl□□in dea haubdhand:□+1.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.golden_pickaxe": "goidpickl□□in dea haubdhand:□+1 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.golden_axe": "goidbarte□□in dea haubdhand:□+6 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.netherite_sword": "netheritschwead□□in dea haubdhand:□+7 oangriffsschadn□-2.4 oangriffsgschwindichkeid",
  "item.minecraft.netherite_shovel": "netheritschaufl□□in dea haubdhand:□+5.5 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.netherite_pickaxe": "netheritspitzhackn□□in dea haubdhand:□+5 oangriffsschadn□-2.8 oangriffsgschwindichkeid",
  "item.minecraft.netherite_axe": "netheritaxn□□in dea haubdhand:□+9 oangriffsschadn□-3 oangriffsgschwindichkeid",
  "item.minecraft.string": "foudn",
  "item.minecraft.feather": "feda",
  "item.minecraft.gunpowder": "schwoazbulva",
  "item.minecraft.wooden_hoe": "hulzhaue□□in dea haubdhand:□-3 oangriffsgschwindichkeid",
  "item.minecraft.stone_hoe": "staahaue□□in dea haubdhand:□-2 oangriffsgschwindichkeid",
  "item.minecraft.iron_hoe": "aasnhaue□□in dea haubdhand:□-1 oangriffsgschwindichkeid",
  "item.minecraft.diamond_hoe": "diormandhaue□□in dea haubdhand:",
  "item.minecraft.golden_hoe": "goidhaue□□in dea haubdhand:□-3 oangriffsgschwindichkeid",
  "item.minecraft.netherite_hoe": "netherithaue□□in dea haubdhand:",
  "item.minecraft.wheat_seeds": "waiznköana",
  "item.minecraft.wheat": "waaz",
  "item.minecraft.bread": "weggla",
  "item.minecraft.leather_helmet": "leddakappn□□oaf dem deetz:□+1 rüsdung",
  "item.minecraft.leather_chestplate": "leddajäggle□□am körpa:□+3 rüsdung",
  "item.minecraft.leather_leggings": "leddahuus□□an den bein'n:□+2 rüsdung",
  "item.minecraft.leather_boots": "leddaschdiefl□□an den ladschn:□+1 rüsdung",
  "item.minecraft.chainmail_helmet": "keddnhaum□□oaf dem deetz:□+2 rüsdung",
  "item.minecraft.chainmail_chestplate": "keddnhemmd□□am körpa:□+5 rüsdung",
  "item.minecraft.chainmail_leggings": "keddnhuus□□an den bein'n:□+4 rüsdung",
  "item.minecraft.chainmail_boots": "keddnschdiefl□□an den ladschn:□+1 rüsdung",
  "item.minecraft.iron_helmet": "aasnhelm□□oaf dem deetz:□+2 rüsdung",
  "item.minecraft.iron_chestplate": "aasnbruasdschild□□am körpa:□+6 rüsdung",
  "item.minecraft.iron_leggings": "aasnboischuz□□an den bein'n:□+5 rüsdung",
  "item.minecraft.iron_boots": "aasnschdiefl□□an den ladschn:□+2 rüsdung",
  "item.minecraft.diamond_helmet": "diormandhelm□□oaf dem deetz:□+3 rüsdung□+2 rüsdungshäaddn",
  "item.minecraft.diamond_chestplate": "diormandbruasdschild□□am körpa:□+8 rüsdung□+2 rüsdungshäaddn",
  "item.minecraft.diamond_leggings": "diormandboischuz□□an den bein'n:□+6 rüsdung□+2 rüsdungshäaddn",
  "item.minecraft.diamond_boots": "diormandschdiefl□□an den ladschn:□+3 rüsdung□+2 rüsdungshäaddn",
  "item.minecraft.golden_helmet": "goidhelm□□oaf dem deetz:□+2 rüsdung",
  "item.minecraft.golden_chestplate": "goidbruasdschild□□am körpa:□+5 rüsdung",
  "item.minecraft.golden_leggings": "goidboischuz□□an den bein'n:□+3 rüsdung",
  "item.minecraft.golden_boots": "goidschdiefl□□an den ladschn:□+1 rüsdung",
  "item.minecraft.netherite_helmet": "netherithelm□□oaf dem deetz:□+3 rüsdung□+3 rüsdungshäaddn□+1 standfesdichkeid",
  "item.minecraft.netherite_chestplate": "netheritbruasdschild□□am körpa:□+8 rüsdung□+3 rüsdungshäaddn□+1 standfesdichkeid",
  "item.minecraft.netherite_leggings": "netheritboischuz□□an den bein'n:□+6 rüsdung□+3 rüsdungshäaddn□+1 standfesdichkeid",
  "item.minecraft.netherite_boots": "netheritschdiefl□□an den ladschn:□+3 rüsdung□+3 rüsdungshäaddn□+1 standfesdichkeid",
  "item.minecraft.flint": "feuasta",
  "item.minecraft.porkchop": "rohs schweinsflasch",
  "item.minecraft.cooked_porkchop": "scheiferla",
  "item.minecraft.painting": "zeichnung",
  "item.minecraft.golden_apple": "goidena abfl",
  "item.minecraft.enchanted_golden_apple": "verzauberda goidena abfl",
  "block.minecraft.oak_sign": "ächahulzschild",
  "block.minecraft.spruce_sign": "fichdnhulzschild",
  "block.minecraft.birch_sign": "berknhulzschild",
  "block.minecraft.jungle_sign": "droubnhulzschild",
  "block.minecraft.acacia_sign": "akazienhulzschild",
  "block.minecraft.dark_oak_sign": "schwoazächahulzschild",
  "block.minecraft.crimson_sign": "karmesinschild",
  "block.minecraft.warped_sign": "wirrschild",
  "item.minecraft.bucket": "aima",
  "item.minecraft.water_bucket": "wassaaima",
  "item.minecraft.lava_bucket": "lovaaima",
  "item.minecraft.minecart": "lore",
  "item.minecraft.saddle": "saddl",
  "item.minecraft.redstone": "redstone-staab",
  "item.minecraft.snowball": "schnähbool",
  "item.minecraft.oak_boat": "ächahulzbood",
  "item.minecraft.leather": "ledda",
  "item.minecraft.milk_bucket": "milliaima",
  "item.minecraft.pufferfish_bucket": "kuglfischaima",
  "item.minecraft.salmon_bucket": "laggsaima",
  "item.minecraft.cod_bucket": "kabljauaima",
  "item.minecraft.tropical_fish_bucket": "drobnfischaima",
  "item.minecraft.brick": "glodds",
  "item.minecraft.clay_ball": "tonklumbn",
  "block.minecraft.dried_kelp_block": "schnähblūk",
  "item.minecraft.paper": "babier",
  "item.minecraft.book": "bouch",
  "item.minecraft.slime_ball": "schloimbool",
  "item.minecraft.chest_minecart": "lore mid druhe",
  "item.minecraft.furnace_minecart": "lore mid ofn",
  "item.minecraft.egg": "gaggeli",
  "item.minecraft.compass": "gommbass",
  "item.minecraft.fishing_rod": "angl",
  "item.minecraft.clock": "uah",
  "item.minecraft.glowstone_dust": "glowstonestaab",
  "item.minecraft.cod": "roha kabljau",
  "item.minecraft.salmon": "rohe laggs",
  "item.minecraft.tropical_fish": "drobnfisch",
  "item.minecraft.pufferfish": "kuglfisch",
  "item.minecraft.cooked_cod": "gbradena kabljau",
  "item.minecraft.cooked_salmon": "gebrodna laggs",
  "item.minecraft.ink_sac": "dindnsagg",
  "item.minecraft.red_dye": "rouda fabbschdoff",
  "item.minecraft.green_dye": "grina fabbschdoff",
  "item.minecraft.cocoa_beans": "kakaobohnn",
  "item.minecraft.lapis_lazuli": "labislazuli",
  "item.minecraft.purple_dye": "violedda fabbschdoff",
  "item.minecraft.cyan_dye": "dürgisa fabbschdoff",
  "item.minecraft.light_gray_dye": "hellgraua fabbschdoff",
  "item.minecraft.gray_dye": "graua fabbschdoff",
  "item.minecraft.pink_dye": "bingga fabbschdoff",
  "item.minecraft.lime_dye": "hellgrina fabbschdoff",
  "item.minecraft.yellow_dye": "gelba fabbschdoff",
  "item.minecraft.light_blue_dye": "hellblaua fabbschdoff",
  "item.minecraft.magenta_dye": "magenda fabbschdoff",
  "item.minecraft.orange_dye": "oranga fabbschdoff",
  "item.minecraft.bone_meal": "gnochnmehl",
  "item.minecraft.blue_dye": "blaua fabbschdoff",
  "item.minecraft.brown_dye": "broauna fabbschdoff",
  "item.minecraft.black_dye": "schwoaza fabbschdoff",
  "item.minecraft.white_dye": "woaßa fabbschdoff",
  "item.minecraft.bone": "gnochn",
  "item.minecraft.sugar": "zugga",
  "block.minecraft.cake": "kuchn",
  "block.minecraft.white_bed": "woaßes bedd",
  "block.minecraft.orange_bed": "oranges bedd",
  "block.minecraft.magenta_bed": "magenda bedd",
  "block.minecraft.light_blue_bed": "hellblaues bedd",
  "block.minecraft.yellow_bed": "gelbes bedd",
  "block.minecraft.lime_bed": "hellgrines bedd",
  "block.minecraft.pink_bed": "bingges bedd",
  "block.minecraft.gray_bed": "graues bedd",
  "block.minecraft.light_gray_bed": "hellgraues bedd",
  "block.minecraft.cyan_bed": "dürgises bedd",
  "block.minecraft.purple_bed": "violeddes bedd",
  "block.minecraft.blue_bed": "blaues bedd",
  "block.minecraft.brown_bed": "broaunes bedd",
  "block.minecraft.green_bed": "grines bedd",
  "block.minecraft.red_bed": "roudes bedd",
  "block.minecraft.black_bed": "schwoazes bedd",
  "item.minecraft.cookie": "blezla",
  "item.minecraft.filled_map": "kadde□#0",
  "item.minecraft.shears": "scher",
  "item.minecraft.melon_slice": "melonscheim",
  "item.minecraft.dried_kelp": "gdrocknedea seedang",
  "item.minecraft.pumpkin_seeds": "kärwissoma",
  "item.minecraft.melon_seeds": "melonsoma",
  "item.minecraft.beef": "rohs rindsfleisch",
  "item.minecraft.cooked_beef": "schdeeg",
  "item.minecraft.chicken": "rohs giegerla",
  "item.minecraft.cooked_chicken": "giegerla",
  "item.minecraft.rotten_flesh": "varoddedes fleisch",
  "item.minecraft.ender_pearl": "enderbeale",
  "item.minecraft.blaze_rod": "lohnrude",
  "item.minecraft.ghast_tear": "ghastdräne",
  "item.minecraft.gold_nugget": "goidglumbn",
  "item.minecraft.nether_wart": "netherwazn",
  "item.minecraft.potion": "net brauchbara drangg□wiakunglos",
  "item.minecraft.glass_bottle": "glosbuddel",
  "item.minecraft.spider_eye": "schbinnaach",
  "item.minecraft.fermented_spider_eye": "fermendiedes schbinnaach",
  "item.minecraft.blaze_powder": "lohnschdaub",
  "item.minecraft.magma_cream": "mochmagreem",
  "block.minecraft.brewing_stand": "brauschdand",
  "block.minecraft.cauldron": "gessl",
  "item.minecraft.ender_eye": "enderach",
  "item.minecraft.glistering_melon_slice": "glitzende melonscheim",
  "item.minecraft.bat_spawn_egg": "fledamaus-spawn-gaggeli",
  "item.minecraft.bee_spawn_egg": "bie-spawn-aa",
  "item.minecraft.blaze_spawn_egg": "lohn-spawn-gaggeli",
  "item.minecraft.cat_spawn_egg": "koatzn-spawn-gaggeli",
  "item.minecraft.cave_spider_spawn_egg": "höhlnschbinn-spawn-gaggeli",
  "item.minecraft.chicken_spawn_egg": "hüecher-spawn-gaggeli",
  "item.minecraft.cod_spawn_egg": "kabljau-spawn-gaggeli",
  "item.minecraft.cow_spawn_egg": "kou-spawn-gaggeli",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-gaggeli",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-gaggeli",
  "item.minecraft.donkey_spawn_egg": "esl-spawn-gaggeli",
  "item.minecraft.drowned_spawn_egg": "erdrunggenen-spawn-gaggeli",
  "item.minecraft.elder_guardian_spawn_egg": "großa-wächda-spawn-gaggeli",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-gaggeli",
  "item.minecraft.endermite_spawn_egg": "endermidn-spawn-gaggeli",
  "item.minecraft.evoker_spawn_egg": "mogie-spawn-gaggeli",
  "item.minecraft.fox_spawn_egg": "fuchs-spawn-gaggeli",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-gaggeli",
  "item.minecraft.guardian_spawn_egg": "wächda-spawn-gaggeli",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-gaggeli",
  "item.minecraft.horse_spawn_egg": "gaul-spawn-gaggeli",
  "item.minecraft.husk_spawn_egg": "wüsdnzombie-spawn-gaggeli",
  "item.minecraft.llama_spawn_egg": "loma-spawn-gaggeli",
  "item.minecraft.magma_cube_spawn_egg": "mochmawüffel-spawn-gaggeli",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-gaggeli",
  "item.minecraft.mule_spawn_egg": "mauldier-spawn-gaggeli",
  "item.minecraft.ocelot_spawn_egg": "ozelodn-spawn-gaggeli",
  "item.minecraft.panda_spawn_egg": "poanda-spawn-gaggeli",
  "item.minecraft.parrot_spawn_egg": "babagein-spawn-gaggeli",
  "item.minecraft.phantom_spawn_egg": "phandom-spawn-gaggeli",
  "item.minecraft.pig_spawn_egg": "schweins-spawn-ei",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-gaggeli",
  "item.minecraft.pillager_spawn_egg": "blündera-spawn-gaggeli",
  "item.minecraft.polar_bear_spawn_egg": "eisbeä-spawn-gaggeli",
  "item.minecraft.pufferfish_spawn_egg": "kuglfisch-spawn-gaggeli",
  "item.minecraft.rabbit_spawn_egg": "karnickel-spawn-gaggeli",
  "item.minecraft.ravager_spawn_egg": "vawüsda-spawn-gaggeli",
  "item.minecraft.salmon_spawn_egg": "laggs-spawn-gaggeli",
  "item.minecraft.sheep_spawn_egg": "hämml-spawn-gaggeli",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-gaggeli",
  "item.minecraft.silverfish_spawn_egg": "silbefisch-spawn-gaggeli",
  "item.minecraft.skeleton_spawn_egg": "sgeledd-spawn-gaggeli",
  "item.minecraft.skeleton_horse_spawn_egg": "sgeleddgaul-spawn-gaggeli",
  "item.minecraft.slime_spawn_egg": "schloim-spawn-gaggeli",
  "item.minecraft.spider_spawn_egg": "schbinn-spawn-gaggeli",
  "item.minecraft.squid_spawn_egg": "dindnfisch-spawn-gaggeli",
  "item.minecraft.stray_spawn_egg": "aiswandra-spawn-gaggeli",
  "item.minecraft.strider_spawn_egg": "schreida-spawn-gaggeli",
  "item.minecraft.trader_llama_spawn_egg": "händlaloma-spawn-gaggeli",
  "item.minecraft.tropical_fish_spawn_egg": "drobnfisch-spawn-gaggeli",
  "item.minecraft.turtle_spawn_egg": "schildgrödn-spawn-gaggeli",
  "item.minecraft.vex_spawn_egg": "gschbensd-spawn-gaggeli",
  "item.minecraft.villager_spawn_egg": "doefbewohne-spawn-gaggeli",
  "item.minecraft.vindicator_spawn_egg": "diena-spawn-gaggeli",
  "item.minecraft.wandering_trader_spawn_egg": "fahrnda-händla-spawn-gaggeli",
  "item.minecraft.witch_spawn_egg": "affarlaa-spawn-gaggeli",
  "item.minecraft.wither_skeleton_spawn_egg": "withersgeledd-spawn-gaggeli",
  "item.minecraft.wolf_spawn_egg": "wolf-spawn-gaggeli",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-gaggeli",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-gaggeli",
  "item.minecraft.zombie_horse_spawn_egg": "zombiegaul-spawn-gaggeli",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedoefbewohne-spawn-gaggeli",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizieada-piglin-spawn-gaggeli",
  "item.minecraft.experience_bottle": "eafohrungsfläschla",
  "item.minecraft.fire_charge": "feuabool",
  "item.minecraft.writable_book": "bouch mid fede",
  "item.minecraft.written_book": "beschriebens bouch",
  "item.minecraft.emerald": "stala",
  "item.minecraft.item_frame": "rahmn",
  "block.minecraft.flower_pot": "blumndobf",
  "item.minecraft.carrot": "karoddn",
  "item.minecraft.potato": "kadoffe",
  "item.minecraft.baked_potato": "ofnkadoffe",
  "item.minecraft.poisonous_potato": "giffdiche kadoffe",
  "item.minecraft.map": "leere kadde",
  "item.minecraft.golden_carrot": "goidene karoddn",
  "block.minecraft.skeleton_skull": "sgeleddschedl",
  "block.minecraft.wither_skeleton_skull": "withersgeleddschedl",
  "block.minecraft.player_head": "schbielakupf",
  "block.minecraft.zombie_head": "zombiekupf",
  "block.minecraft.creeper_head": "creeperkupf",
  "block.minecraft.dragon_head": "drachnkupf",
  "item.minecraft.carrot_on_a_stick": "karodde am schdegge",
  "item.minecraft.warped_fungus_on_a_stick": "wirrpilzrudn",
  "item.minecraft.nether_star": "netherschdean",
  "item.minecraft.pumpkin_pie": "kärwiskuchn",
  "item.minecraft.firework_rocket": "feuaweaksrachede",
  "item.minecraft.firework_star": "feuaweaksschdean",
  "item.minecraft.enchanted_book": "verzauberds bouch",
  "item.minecraft.nether_brick": "netherglödds",
  "item.minecraft.quartz": "netherkwarz",
  "item.minecraft.tnt_minecart": "lore mid dnd",
  "item.minecraft.hopper_minecart": "lore mid drichda",
  "item.minecraft.prismarine_shard": "brismarinscherbm",
  "item.minecraft.prismarine_crystals": "brismaringrissdall",
  "item.minecraft.rabbit": "rohes kaniggl",
  "item.minecraft.cooked_rabbit": "gbratenes kaniggl",
  "item.minecraft.rabbit_stew": "kanigglragout",
  "item.minecraft.rabbit_foot": "kanigglpfode",
  "item.minecraft.rabbit_hide": "kanigglfell",
  "item.minecraft.armor_stand": "rüsdungsschdände",
  "item.minecraft.iron_horse_armor": "aasne pfeddrüsdung",
  "item.minecraft.golden_horse_armor": "goidene pfeddrüsdung",
  "item.minecraft.diamond_horse_armor": "diormandpfeddrüsdung",
  "item.minecraft.leather_horse_armor": "leddane pfeddrüsdung",
  "item.minecraft.lead": "laine",
  "item.minecraft.name_tag": "noamensschild",
  "item.minecraft.command_block_minecart": "lore mid bfehlsblogg",
  "item.minecraft.mutton": "rohes hammlflaisch",
  "item.minecraft.cooked_mutton": "gbratenes hammlflaisch",
  "block.minecraft.white_banner": "woaßes banner",
  "block.minecraft.orange_banner": "oranges banner",
  "block.minecraft.magenta_banner": "magenda banner",
  "block.minecraft.light_blue_banner": "hellblaues banner",
  "block.minecraft.yellow_banner": "gelbes banner",
  "block.minecraft.lime_banner": "hellgrines banner",
  "block.minecraft.pink_banner": "bingges banner",
  "block.minecraft.gray_banner": "graues banner",
  "block.minecraft.light_gray_banner": "hellgraues banner",
  "block.minecraft.cyan_banner": "dürgises banner",
  "block.minecraft.purple_banner": "violeddes banner",
  "block.minecraft.blue_banner": "blaues banner",
  "block.minecraft.brown_banner": "broaunes banner",
  "block.minecraft.green_banner": "grines banner",
  "block.minecraft.red_banner": "roudes banner",
  "block.minecraft.black_banner": "schwoazes banner",
  "item.minecraft.end_crystal": "endergrissdall",
  "item.minecraft.chorus_fruit": "chorusfruchd",
  "item.minecraft.popped_chorus_fruit": "geblatzde chorusfruchd",
  "item.minecraft.beetroot": "roude bede",
  "item.minecraft.beetroot_seeds": "roude-bede-soma",
  "item.minecraft.beetroot_soup": "borschtsch",
  "item.minecraft.dragon_breath": "drochnadem",
  "item.minecraft.splash_potion": "net brauchbara drangg□wiakunglos",
  "item.minecraft.spectral_arrow": "spekdralpfail",
  "item.minecraft.tipped_arrow": "ned heastellbara gdränkda pfail□wiakunglos",
  "item.minecraft.lingering_potion": "ned brauchbara veaweildrangg□wiakunglos",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "elydre",
  "item.minecraft.spruce_boat": "fichdnhulzbood",
  "item.minecraft.birch_boat": "berknhulzbood",
  "item.minecraft.jungle_boat": "droubnhulzbood",
  "item.minecraft.acacia_boat": "akazienhulzbood",
  "item.minecraft.dark_oak_boat": "schwoazächahulzbood",
  "item.minecraft.totem_of_undying": "dodem der unschdebblichgaad",
  "item.minecraft.shulker_shell": "shulkerschole",
  "item.minecraft.iron_nugget": "aasnglumbn",
  "item.minecraft.knowledge_book": "bouch des wissns",
  "item.minecraft.debug_stick": "debug-schdegge",
  "item.minecraft.music_disc_13": "schallbladdn□c418 - 13",
  "item.minecraft.music_disc_cat": "schallbladdn□c418 - cat",
  "item.minecraft.music_disc_blocks": "schallbladdn□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schallbladdn□c418 - chirp",
  "item.minecraft.music_disc_far": "schallbladdn□c418 - far",
  "item.minecraft.music_disc_mall": "schallbladdn□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallbladdn□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallbladdn□c418 - stal",
  "item.minecraft.music_disc_strad": "schallbladdn□c418 - strad",
  "item.minecraft.music_disc_ward": "schallbladdn□c418 - ward",
  "item.minecraft.music_disc_11": "schallbladdn□c418 - 11",
  "item.minecraft.music_disc_wait": "schallbladdn□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallbladdn□lena raine - pigstep",
  "item.minecraft.trident": "draizagg□□in dea haubdhand:□+8 oangriffsschadn□-2.9 oangriffsgschwindichkeid",
  "item.minecraft.phantom_membrane": "phandomhaud",
  "item.minecraft.nautilus_shell": "naudilusschole",
  "item.minecraft.heart_of_the_sea": "hätz vom meer",
  "item.minecraft.crossbow": "aambrusd",
  "item.minecraft.suspicious_stew": "seldsame suppn",
  "block.minecraft.loom": "webstuhl",
  "item.minecraft.flower_banner_pattern": "bannermuschder□bluma",
  "item.minecraft.creeper_banner_pattern": "bannermuschder□creeper",
  "item.minecraft.skull_banner_pattern": "bannermuschder□schedl",
  "item.minecraft.mojang_banner_pattern": "bannermuschder□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannermuschder□globus",
  "item.minecraft.piglin_banner_pattern": "bannermuschder□schnauzn",
  "block.minecraft.composter": "komposda",
  "block.minecraft.barrel": "fässla",
  "block.minecraft.smoker": "räuchaofn",
  "block.minecraft.blast_furnace": "schmelzofn",
  "block.minecraft.cartography_table": "kaddndisch",
  "block.minecraft.fletching_table": "bognertisch",
  "block.minecraft.grindstone": "schleifstaa",
  "block.minecraft.lectern": "lesebuld",
  "block.minecraft.smithing_table": "schmiedetisch",
  "block.minecraft.stonecutter": "schdoisäch",
  "block.minecraft.bell": "glockn",
  "block.minecraft.lantern": "ladeane",
  "block.minecraft.soul_lantern": "seelnlaterne",
  "item.minecraft.sweet_berries": "süßbeean",
  "block.minecraft.campfire": "lachafeua",
  "block.minecraft.soul_campfire": "seelnlagafeua",
  "block.minecraft.shroomlight": "pilzliachd",
  "item.minecraft.honeycomb": "honichwòwe",
  "block.minecraft.bee_nest": "bienanest",
  "block.minecraft.beehive": "bienaschdogg",
  "item.minecraft.honey_bottle": "honichbuddel",
  "block.minecraft.honey_block": "honigblogg",
  "block.minecraft.honeycomb_block": "knochnblogg",
  "block.minecraft.lodestone": "leidstoa",
  "block.minecraft.netherite_block": "netheritblogg",
  "block.minecraft.ancient_debris": "antiga schrodt",
  "block.minecraft.target": "zielscheibenblogg",
  "block.minecraft.crying_obsidian": "weinenda obsidian",
  "block.minecraft.blackstone": "schwoazschdoi",
  "block.minecraft.blackstone_slab": "schwoazschdoischdufn",
  "block.minecraft.blackstone_stairs": "schwoazschdoidrebbn",
  "block.minecraft.gilded_blackstone": "goidduachzochena schwoazschdoi",
  "block.minecraft.polished_blackstone": "poliada schwoazschdoi",
  "block.minecraft.polished_blackstone_slab": "poliada schwoazschdoischdufn",
  "block.minecraft.polished_blackstone_stairs": "poliada schwoazschdoidrebbn",
  "block.minecraft.chiseled_polished_blackstone": "gmeißelda poliada schwoazschdoi",
  "block.minecraft.polished_blackstone_bricks": "poliada schwoazschdoiziegl",
  "block.minecraft.polished_blackstone_brick_slab": "poliada schwoazschdoizieglschdufn",
  "block.minecraft.polished_blackstone_brick_stairs": "poliada schwoazschdoiziegldrebbn",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissicha poliada schwoazschdoiziegl",
  "block.minecraft.respawn_anchor": "seelnanka",
}
export const fra_de = items; 
